import axios, { AxiosResponse } from 'axios';

export interface IJourneyApi {
  checkIban(iban: string): Promise<AxiosResponse<any>>;
  getCheckSum(subscriptionNumber: number, shortOfferCode: string): Promise<AxiosResponse<any>>;
}

export class JourneyApi implements IJourneyApi {
  async checkIban(iban: string): Promise<AxiosResponse<any>> {
    return await axios.get('journey/banking-check?iban=' + iban);
  }

  async getCheckSum(subscriptionNumber: number, shortOfferCode: string): Promise<AxiosResponse<any>> {
    return await axios.get(`journey/check-sum/${subscriptionNumber}/${shortOfferCode}`);
  }
}
